//* Import API configurations
import { api } from "../../../services/apis/configs/axiosConfigs";

//* Import API URI constant
import { API_URI } from "../../../constants/consts";

//? Import types from types
import { DemandTag } from "./types/types";



// API methods for Demands operations
export const demandsTagAPI = {
  // Create a new Demands
  create: async function (
    data: { demand_id: string; tag_id: string },
    token: string
  ): Promise<DemandTag> {
    return api
      .request({
        url: `${API_URI}/admin/private/demand-tags`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data,
      })
      .then((response) => response.data.data)
      .catch((error) => {
        console.error("Error creating Demands:", error, data);
        throw new Error("Failed to create Demands");
      });
  },

  // Delete an DemandsTags by ID
  delete: async function (id: string, token: string): Promise<void> {
    return api
      .request({
        url: `${API_URI}/admin/private/demand-tags/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {})
      .catch((error) => {
        console.error("Error deleting Demands:", error);
        throw new Error("Failed to delete Demands");
      });
  },
};
